<template>
    <div class="locations uk-margin-large-top">
        <div class="type uk-h5">{{ $tc('message.location', 2) }}</div>

        <div class="">
            <template v-if="scrollable">
                <div class="">
                    <simplebar class="list" data-simplebar-auto-hide="false" data-simplebar-click-on-track="false" :classNames="sbClasses">
                        <ul class="uk-list">
                            <li v-for="(item, key) in availableLocations" :key="key">
                                <button 
                                    @click="filterLocation(item.id)"
                                    class="uk-text-font-default uk-text-default uk-flex uk-flex-middle"
                                    :data-location="item.name"
                                    :title="item.name" type="button"
                                >
                                    <input class="uk-checkbox uk-margin-remove-top uk-margin-small-right" type="checkbox" :checked="activeFilters.locations.indexOf(item.id) > -1">
                                    <span>{{ item.name }}</span>
                                </button>
                            </li>
                        </ul>
                    </simplebar>
                </div>
            </template>
            <template v-else>
                <ul class="uk-list">
                    <li v-for="(item, key) in availableLocations" :key="key">
                        <button 
                            @click="filterLocation(item.id)"
                            class="uk-text-font-default uk-text-default uk-flex uk-flex-middle"
                            :data-location="item.name"
                            :title="item.name" type="button"
                        >
                            <input class="uk-checkbox uk-margin-remove-top uk-margin-small-right" type="checkbox" :checked="activeFilters.locations.indexOf(item.id) > -1">
                            <span>{{ item.name }}</span>
                        </button>
                    </li>
                </ul>
            </template>  
        </div>
    </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

export default {
    name: 'location-filter',
    components: {
        simplebar
    },
    props: ['availableLocations', 'activeLocationsName', 'activeFilters', 'scrollable'],
    data() {
        return {
            sbClasses: {
                offset: 'simplebar-offset uk-nav-side-gradient-bottom-60',
                contentWrapper: 'simplebar-content-wrapper js-nav-alphabet-list',
            }
        }
    },
    methods: {
        filterLocation(id) {
            this.$emit('location-filtered', id)
        }
    },
    mounted: function ()     {
        jQuery('.js-nav-alphabet-list').on('scroll', function () {
            if (this.scrollTop > (this.scrollHeight - this.offsetHeight - 150)) {
                this.parentNode.classList.add('uk-nav-side-gradient-hidden');
            } else if (this.parentNode.classList.contains('uk-nav-side-gradient-hidden')) {
                this.parentNode.classList.remove('uk-nav-side-gradient-hidden');
            }
        });
    },
};
</script>

<style lang="scss">
    .list {
        height: 488px;
    }
    .simplebar-track {
        background: #E9ECF0;
        &.simplebar-vertical {
            width: 6px;
            border-radius: 3px;
        }
    }
    .simplebar-scrollbar {
        &.simplebar-visible {
            &:before {
                background: #CCD6E3;
                opacity: 1;
            }
        }
        &:before {
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
        }
    }
</style>
